import { render } from "./Opening.vue?vue&type=template&id=0d209c76"
import script from "./Opening.vue?vue&type=script&lang=js"
export * from "./Opening.vue?vue&type=script&lang=js"
script.render = render

export default script